import { render } from "./Reservation.vue?vue&type=template&id=6f3db63c"
import script from "./Reservation.vue?vue&type=script&lang=ts"
export * from "./Reservation.vue?vue&type=script&lang=ts"
script.render = render

export default script